import { Component, Input, OnInit } from '@angular/core';
import { DocumentDto } from '@bo-client/shared/models/documentDto';

@Component({
  selector: 'app-documents-upload-summary',
  templateUrl: './documents-upload-summary.component.html',
  styleUrls: ['./documents-upload-summary.component.scss']
})
export class DocumentsUploadSummaryComponent implements OnInit {
  @Input() uploads: DocumentDto[];

  constructor() {}

  ngOnInit(): void {}
}
